import { split, replace, trimStart, trimEnd, endsWith, substring, isNullOrWhiteSpace } from "../fable-library.3.7.20/String.js";
import { some } from "../fable-library.3.7.20/Option.js";
import { takeWhile as takeWhile_1, skipWhile, toArray, empty, reverse, cons, map as map_1, ofArray, tail, head, isEmpty } from "../fable-library.3.7.20/List.js";
import { forAll, empty as empty_1, singleton, collect, delay, toList, windowed, exists, min, isEmpty as isEmpty_1, filter, takeWhile, length, map } from "../fable-library.3.7.20/Seq.js";
import { isLetter, isWhiteSpace } from "../fable-library.3.7.20/Char.js";
import { equals, comparePrimitives } from "../fable-library.3.7.20/Util.js";
import { FSharpRef } from "../fable-library.3.7.20/Types.js";
import { MarkdownRange } from "./Range.fs.js";
import { List_partitionWhile } from "./Collections.fs.js";
import { tryGetValue } from "../fable-library.3.7.20/MapUtil.js";

export function Log_warn(s) {
    console.log(s);
}

export function String_$007CWhiteSpace$007C_$007C(s) {
    if (isNullOrWhiteSpace(s)) {
        return some(void 0);
    }
    else {
        return void 0;
    }
}

export function String_$007CTrimBoth$007C(text) {
    return text.trim();
}

export function String_$007CStartsWith$007C_$007C(start, text) {
    if (text.indexOf(start) === 0) {
        return substring(text, start.length);
    }
    else {
        return void 0;
    }
}

export function String_$007CStartsWithTrim$007C_$007C(start, text) {
    if (text.indexOf(start) === 0) {
        return substring(text, start.length).trim();
    }
    else {
        return void 0;
    }
}

export function String_$007CStartsAndEndsWith$007C_$007C(starts, ends, s) {
    if (((s.indexOf(starts) === 0) && endsWith(s, ends)) && (s.length >= (starts.length + ends.length))) {
        return substring(s, starts.length, (s.length - starts.length) - ends.length);
    }
    else {
        return void 0;
    }
}

export function String_$007CStartsAndEndsWithTrim$007C_$007C(args_, args__1, _arg) {
    let activePatternResult;
    const tupledArg = [args_, args__1];
    activePatternResult = String_$007CStartsAndEndsWith$007C_$007C(tupledArg[0], tupledArg[1], _arg);
    if (activePatternResult != null) {
        const activePatternResult_1 = String_$007CTrimBoth$007C(activePatternResult);
        return activePatternResult_1;
    }
    else {
        return void 0;
    }
}

export function String_$007CStartsWithWrapped$007C_$007C(starts, ends, text) {
    if (text.indexOf(starts) === 0) {
        const id = text.indexOf(ends, starts.length) | 0;
        if (id >= 0) {
            return [substring(text, starts.length, id - starts.length), substring(text, id + ends.length, (text.length - id) - ends.length)];
        }
        else {
            return void 0;
        }
    }
    else {
        return void 0;
    }
}

export function String_$007CSkipSingleLine$007C(text) {
    const tryEol = (eolList_mut) => {
        tryEol:
        while (true) {
            const eolList = eolList_mut;
            if (!isEmpty(eolList)) {
                const h = head(eolList);
                const matchValue = text.indexOf(h) | 0;
                if (matchValue < 0) {
                    eolList_mut = tail(eolList);
                    continue tryEol;
                }
                else {
                    return substring(text, matchValue + h.length);
                }
            }
            else {
                return text;
            }
            break;
        }
    };
    const result = tryEol(ofArray(["\r\n", "\n"]));
    const skipped = substring(text, 0, text.length - result.length);
    if (!isNullOrWhiteSpace(skipped)) {
        Log_warn(`skipped '${skipped}' which contains non-whitespace character!`);
    }
    if (result === text) {
        Log_warn(`could not skip a line of ${text}, because no line-ending character was found!`);
    }
    return result;
}

export function String_removeSpaces(lines) {
    let spaces;
    const xs = map((line) => length(takeWhile(isWhiteSpace, line.split(""))), filter((arg_1) => (!isNullOrWhiteSpace(arg_1)), lines));
    spaces = (isEmpty_1(xs) ? 0 : min(xs, {
        Compare: comparePrimitives,
    }));
    return map_1((line_1) => {
        if (isNullOrWhiteSpace(line_1)) {
            return "";
        }
        else {
            return substring(line_1, spaces);
        }
    }, lines);
}

export function StringPosition_$007CWhiteSpace$007C_$007C(s, _n) {
    if (isNullOrWhiteSpace(s)) {
        return some(void 0);
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CUnindented$007C_$007C(s, _n) {
    if ((!isNullOrWhiteSpace(s)) && (s.trimStart() === s)) {
        return some(void 0);
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CTrimBoth$007C(text, n) {
    let inputRecord, StartColumn, EndColumn;
    const trimmedStart = text.trimStart();
    const trimmed = trimmedStart.trimEnd();
    return [trimmed, (inputRecord = (new FSharpRef(n)), (StartColumn = (((n.StartColumn + text.length) - trimmedStart.length) | 0), (EndColumn = (((n.EndColumn - trimmedStart.length) + trimmed.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, EndColumn))))];
}

export function StringPosition_$007CTrimEnd$007C(text, n) {
    let inputRecord, EndColumn;
    const trimmed = text.trimEnd();
    return [trimmed, (inputRecord = (new FSharpRef(n)), (EndColumn = (((n.EndColumn - text.length) + trimmed.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, inputRecord.contents.StartColumn, inputRecord.contents.EndLine, EndColumn)))];
}

export function StringPosition_$007CTrimStart$007C(text, n) {
    let inputRecord, StartColumn;
    const trimmed = text.trimStart();
    return [trimmed, (inputRecord = (new FSharpRef(n)), (StartColumn = (((n.StartColumn + text.length) - trimmed.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, inputRecord.contents.EndColumn)))];
}

export function StringPosition_$007CTrimEndUsing$007C(chars, text, n) {
    let inputRecord, EndColumn;
    const trimmed = trimEnd(text, ...Array.from(chars));
    return [trimmed, (inputRecord = (new FSharpRef(n)), (EndColumn = (((n.EndColumn - text.length) + trimmed.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, inputRecord.contents.StartColumn, inputRecord.contents.EndLine, EndColumn)))];
}

export function StringPosition_$007CTrimStartAndCount$007C(text, n) {
    let inputRecord, StartColumn;
    const trimmed = trimStart(text, " ", "\t");
    const len = (text.length - trimmed.length) | 0;
    return [len, replace(substring(text, 0, len), "\t", "    ").length, [trimmed, (inputRecord = (new FSharpRef(n)), (StartColumn = (((n.StartColumn + text.length) - trimmed.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, inputRecord.contents.EndColumn)))]];
}

export function StringPosition_$007CStartsWithAny$007C_$007C(starts, text, _n) {
    if (exists((arg) => (text.indexOf(arg) === 0), starts)) {
        return some(void 0);
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CStartsWith$007C_$007C(start, text, n) {
    let inputRecord, StartColumn;
    if (text.indexOf(start) === 0) {
        return [substring(text, start.length), (inputRecord = (new FSharpRef(n)), (StartColumn = (((n.StartColumn + text.length) - start.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, inputRecord.contents.EndColumn)))];
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CStartsWithTrim$007C_$007C(start, text, n) {
    let inputRecord, StartColumn;
    if (text.indexOf(start) === 0) {
        return [substring(text, start.length).trim(), (inputRecord = (new FSharpRef(n)), (StartColumn = (((n.StartColumn + text.length) - start.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, inputRecord.contents.EndColumn)))];
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CStartsWithNTimesTrimIgnoreStartWhitespace$007C_$007C(start, text, _n) {
    if (text.indexOf(start) >= 0) {
        const beforeStart = substring(text, 0, text.indexOf(start));
        if (isNullOrWhiteSpace(beforeStart)) {
            const startAndRest = substring(text, beforeStart.length);
            const startNum = length(takeWhile((y) => (start === y), map((chars) => (chars.join('')), windowed(start.length, startAndRest.split(""))))) | 0;
            return [startNum, beforeStart.length, substring(text, beforeStart.length + (start.length * startNum)).trim()];
        }
        else {
            return void 0;
        }
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CStartsAndEndsWith$007C_$007C(starts, ends, s, n) {
    let inputRecord, StartColumn, EndColumn;
    if (((s.indexOf(starts) === 0) && endsWith(s, ends)) && (s.length >= (starts.length + ends.length))) {
        return [substring(s, starts.length, (s.length - starts.length) - ends.length), (inputRecord = (new FSharpRef(n)), (StartColumn = (((n.StartColumn + s.length) - starts.length) | 0), (EndColumn = (((n.EndColumn - s.length) + ends.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, EndColumn))))];
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CStartsAndEndsWithTrim$007C_$007C(args_, args__1, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    let activePatternResult;
    const tupledArg = [args_, args__1];
    activePatternResult = StringPosition_$007CStartsAndEndsWith$007C_$007C(tupledArg[0], tupledArg[1], _arg[0], _arg[1]);
    if (activePatternResult != null) {
        let activePatternResult_1;
        const tupledArg_1 = activePatternResult;
        activePatternResult_1 = StringPosition_$007CTrimBoth$007C(tupledArg_1[0], tupledArg_1[1]);
        return activePatternResult_1;
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CStartsWithRepeated$007C_$007C(repeated, text, ln) {
    let inputRecord;
    const loop = (i_mut) => {
        loop:
        while (true) {
            const i = i_mut;
            if (i === text.length) {
                return i | 0;
            }
            else if (text[i] !== repeated[i % repeated.length]) {
                return i | 0;
            }
            else {
                i_mut = (i + 1);
                continue loop;
            }
            break;
        }
    };
    const n = loop(0) | 0;
    if ((n === 0) ? true : ((n % repeated.length) !== 0)) {
        return void 0;
    }
    else {
        return [~(~(n / repeated.length)), [substring(text, n, text.length - n), (inputRecord = (new FSharpRef(ln)), new MarkdownRange(inputRecord.contents.StartLine, n, inputRecord.contents.EndLine, inputRecord.contents.EndColumn))]];
    }
}

export function StringPosition_$007CStartsWithWrapped$007C_$007C(starts, ends, text, n) {
    let inputRecord, StartColumn;
    if (text.indexOf(starts) === 0) {
        const id = text.indexOf(ends, starts.length) | 0;
        if (id >= 0) {
            return [substring(text, starts.length, id - starts.length), [substring(text, id + ends.length, (text.length - id) - ends.length), (inputRecord = (new FSharpRef(n)), (StartColumn = ((id + ends.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, inputRecord.contents.EndColumn)))]];
        }
        else {
            return void 0;
        }
    }
    else {
        return void 0;
    }
}

export function StringPosition_$007CEqualsRepeated$007C_$007C(repeated, _n, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    let pattern_matching_result;
    const activePatternResult = StringPosition_$007CStartsWithRepeated$007C_$007C(repeated, _arg[0], _arg[1]);
    if (activePatternResult != null) {
        if (activePatternResult[1][0] === "") {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return some(void 0);
        }
        case 1: {
            return void 0;
        }
    }
}

export function List_$007CBracketDelimited$007C_$007C(startc, endc, input) {
    const loop = (acc_mut, count_mut, _arg_mut) => {
        loop:
        while (true) {
            const acc = acc_mut, count = count_mut, _arg = _arg_mut;
            let pattern_matching_result, x_10, xs_10, x_11, xs_11, x_12, xs_12, x_13, xs_13, x_14, xs_14;
            if (isEmpty(_arg)) {
                pattern_matching_result = 5;
            }
            else if (head(_arg) === "\\") {
                if (!isEmpty(tail(_arg))) {
                    if (head(tail(_arg)) === endc) {
                        pattern_matching_result = 0;
                        x_10 = head(tail(_arg));
                        xs_10 = tail(tail(_arg));
                    }
                    else if ((head(_arg) === endc) && (count === 0)) {
                        pattern_matching_result = 1;
                        x_11 = head(_arg);
                        xs_11 = tail(_arg);
                    }
                    else if (head(_arg) === endc) {
                        pattern_matching_result = 2;
                        x_12 = head(_arg);
                        xs_12 = tail(_arg);
                    }
                    else if (head(_arg) === startc) {
                        pattern_matching_result = 3;
                        x_13 = head(_arg);
                        xs_13 = tail(_arg);
                    }
                    else {
                        pattern_matching_result = 4;
                        x_14 = head(_arg);
                        xs_14 = tail(_arg);
                    }
                }
                else if ((head(_arg) === endc) && (count === 0)) {
                    pattern_matching_result = 1;
                    x_11 = head(_arg);
                    xs_11 = tail(_arg);
                }
                else if (head(_arg) === endc) {
                    pattern_matching_result = 2;
                    x_12 = head(_arg);
                    xs_12 = tail(_arg);
                }
                else if (head(_arg) === startc) {
                    pattern_matching_result = 3;
                    x_13 = head(_arg);
                    xs_13 = tail(_arg);
                }
                else {
                    pattern_matching_result = 4;
                    x_14 = head(_arg);
                    xs_14 = tail(_arg);
                }
            }
            else if ((head(_arg) === endc) && (count === 0)) {
                pattern_matching_result = 1;
                x_11 = head(_arg);
                xs_11 = tail(_arg);
            }
            else if (head(_arg) === endc) {
                pattern_matching_result = 2;
                x_12 = head(_arg);
                xs_12 = tail(_arg);
            }
            else if (head(_arg) === startc) {
                pattern_matching_result = 3;
                x_13 = head(_arg);
                xs_13 = tail(_arg);
            }
            else {
                pattern_matching_result = 4;
                x_14 = head(_arg);
                xs_14 = tail(_arg);
            }
            switch (pattern_matching_result) {
                case 0: {
                    acc_mut = cons(x_10, acc);
                    count_mut = count;
                    _arg_mut = xs_10;
                    continue loop;
                }
                case 1: {
                    return [reverse(acc), xs_11];
                }
                case 2: {
                    acc_mut = cons(x_12, acc);
                    count_mut = (count - 1);
                    _arg_mut = xs_12;
                    continue loop;
                }
                case 3: {
                    acc_mut = cons(x_13, acc);
                    count_mut = (count + 1);
                    _arg_mut = xs_13;
                    continue loop;
                }
                case 4: {
                    acc_mut = cons(x_14, acc);
                    count_mut = count;
                    _arg_mut = xs_14;
                    continue loop;
                }
                case 5: {
                    return void 0;
                }
            }
            break;
        }
    };
    let pattern_matching_result_1, x_16, xs_16;
    if (!isEmpty(input)) {
        if (head(input) === startc) {
            pattern_matching_result_1 = 0;
            x_16 = head(input);
            xs_16 = tail(input);
        }
        else {
            pattern_matching_result_1 = 1;
        }
    }
    else {
        pattern_matching_result_1 = 1;
    }
    switch (pattern_matching_result_1) {
        case 0: {
            return loop(empty(), 0, xs_16);
        }
        case 1: {
            return void 0;
        }
    }
}

export function List_$007CAsString$007C(chars) {
    return toArray(chars).join('');
}

export function Lines_$007CTrimBlank$007C(lines) {
    return reverse(skipWhile((tupledArg_1) => isNullOrWhiteSpace(tupledArg_1[0]), reverse(skipWhile((tupledArg) => isNullOrWhiteSpace(tupledArg[0]), lines))));
}

export function Lines_$007CTakeStartingWithOrBlank$007C_$007C(start, input) {
    const matchValue = List_partitionWhile((s) => {
        if (isNullOrWhiteSpace(s)) {
            return true;
        }
        else {
            return s.indexOf(start) === 0;
        }
    }, input);
    if (!equals(matchValue[0], empty())) {
        return [matchValue[0], matchValue[1]];
    }
    else {
        return void 0;
    }
}

export function Lines_$007CTakeCodeBlock$007C_$007C(input) {
    const spaceNum = 4;
    const matchValue = List_partitionWhile((tupledArg) => {
        const s_1 = tupledArg[0];
        if (isNullOrWhiteSpace(s_1)) {
            return true;
        }
        else {
            const normalized = replace(s_1, "\t", "    ");
            return (normalized.length >= spaceNum) && (substring(normalized, 0, spaceNum) === (Array(spaceNum + 1).join(" ")));
        }
    }, input);
    if ((!equals(matchValue[0], empty())) && (spaceNum >= 4)) {
        return [spaceNum, matchValue[0], matchValue[1]];
    }
    else {
        return void 0;
    }
}

export function Lines_$007CTrimBlankStart$007C(lines) {
    return [takeWhile_1((tupledArg) => isNullOrWhiteSpace(tupledArg[0]), lines), skipWhile((tupledArg_1) => isNullOrWhiteSpace(tupledArg_1[0]), lines)];
}

export function Lines_$007CTrimParagraphLines$007C(lines) {
    return map_1((tupledArg_1) => {
        let inputRecord, EndColumn;
        const s = tupledArg_1[0];
        const n_1 = tupledArg_1[1];
        const endsWithTwoSpaces = endsWith(s, "  ");
        const trimmed = trimEnd(s, " ") + (endsWithTwoSpaces ? "  " : "");
        return [trimmed, (inputRecord = (new FSharpRef(n_1)), (EndColumn = (((n_1.EndColumn - s.length) + trimmed.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, inputRecord.contents.StartColumn, inputRecord.contents.EndLine, EndColumn)))];
    }, map_1((tupledArg) => StringPosition_$007CTrimStart$007C(tupledArg[0], tupledArg[1]), lines));
}

export function $007CLet$007C(a, b) {
    return [a, b];
}

export function $007CParseCommands$007C_$007C(str) {
    const kvs = toList(delay(() => collect((cmd) => {
        const kv = split(cmd, ["=", ":"]);
        return (kv.length === 2) ? singleton([kv[0].trim(), kv[1].trim()]) : ((kv.length === 1) ? singleton([kv[0].trim(), ""]) : empty_1());
    }, split(str, [","], null, 0))));
    if (forAll((arg) => forAll((c) => {
        if (isLetter(c) ? true : (c === "_")) {
            return true;
        }
        else {
            return c === "-";
        }
    }, arg[0].split("")), kvs) && (!equals(kvs, empty()))) {
        return new Map(kvs);
    }
    else {
        return void 0;
    }
}

export function $007CParseCommand$007C_$007C(cmd) {
    const kv = split(cmd, ["=", ":"]);
    if ((kv.length >= 1) && (!forAll(isLetter, kv[0].split("")))) {
        return void 0;
    }
    else if (kv.length === 2) {
        return [kv[0].trim(), kv[1].trim()];
    }
    else if (kv.length === 1) {
        return [kv[0].trim(), ""];
    }
    else {
        return void 0;
    }
}

export function $007CCommand$007C_$007C(k, d) {
    let matchValue;
    let outArg = null;
    matchValue = [tryGetValue(d, k, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return some(matchValue[1]);
    }
    else {
        return void 0;
    }
}

